module.exports = __webpack_public_path__ + "static/scale-model-of-hower-house-at-the-university-of-akron-in-akron-ohio-f4c515cc2821db04c4fe4fc293ae3045.png";